




import React from "react";

const vehicles = [
  {
    img: "/images/fleets/Aura.jpg",
    price: "₹12/km",
    name: "Hyundai Aura",
    seats: "4 Seat",
    bags: "2 Bags",
    type: "Sedan",
  },
  {
    img: "/images/fleets/Dzire.jpg",
    price: "₹13/km",
    name: "Maruti Suzuki Dzire",
    seats: "4 Seat",
    bags: "2 Bags",
    type: "Sedan",
  },
  {
    img: "/images/fleets/Ertiga.jpg",
    price: "₹16/km",
    name: "Maruti Suzuki Ertiga",
    seats: "6 Seat",
    bags: "4 Bags",
    type: "MPV",
  },
  {
    img: "/images/fleets/Kia.jpg",
    price: "₹18/km",
    name: "Kia Carens",
    seats: "6 Seat",
    bags: "4 Bags",
    type: "MPV",
  },

  {
    img: "/images/fleets/Innova-Crysta.jpg",
    price: "₹24/km",
    name: "Toyota Innova Crysta",
    seats: "7 Seat",
    bags: "5 Bags",
    type: "Premium SUV",
  },
{
  img: "/images/fleets/urbania.jpg",
  price: "₹20/km",
  name: "Urbania Van",
  seats: "17 Seater",
  bags: "5 Bags",
  type: "Luxury Van",
},
];

const VehicleFleet = () => {
  return (
    <div className="section-full p-t150 p-b120 site-bg-white twm-blog-section-wrap">
      <div className="container-fluid">

        {/* TITLE */}
        <div className="section-head center">
          <div className="twm-sm-title left">Choose your car</div>
          <h2 className="twm-large-title site-text-dark">
            Our Vehicle Fleet
          </h2>
        </div>

        {/* VEHICLE GRID */}
        <div className="row">
          {vehicles.map((car, index) => (
            <div className="col-xl-4 col-lg-4 col-md-6 m-b30" key={index}>
              <div className="twm-vehicle-fleet-bx">

                {/* IMAGE */}
                <div className="twm-media">
                  <div className="twm-media-pic">
                    <img src={car.img} alt={car.name} />
                  </div>
                </div>

                {/* CONTENT */}
                <div className="twm-vehicle-fleet-content">

                  <h3 className="twm-v-title">
                    <a href="/booking" className="darkcolo">
                      {car.name}
                    </a>
                  </h3>

                  {/* <p style={{ marginBottom: "8px", fontWeight: "600" }}>
                    {car.price}
                  </p> */}

                  {/* DYNAMIC FEATURES */}
                  <ul className="twm-vehicle-facility">
                    <li><span>🚗</span> {car.seats}</li>
                    <li><span>🧳</span> {car.bags}</li>
                    <li><span>🚙</span> {car.type}</li>
                  </ul>

                </div>

              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default VehicleFleet;